/* Sova shared helpers */
window.SovaMoney = (function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) return '0';

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  /**
   * Formats cents using the store's own money format string
   * (e.g. "${{amount}}", "{{amount_with_comma_separator}} kr").
   */
  function format(cents, moneyFormat) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = moneyFormat || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    if (!match) return fmt;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' '); break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return fmt.replace(placeholder, value);
  }

  return { format: format };
})();
